const IconCalendar = ({ className }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="2.5" y="4" width="15" height="13.5" rx="2" stroke="currentColor" strokeWidth="1.4" />
      <path d="M2.5 8H17.5" stroke="currentColor" strokeWidth="1.4" />
      <path d="M6 2.5V5.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      <path d="M14 2.5V5.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
};

export default IconCalendar;
